import axios from 'axios'

export class Benutzer{
    static async get(konvKey){
        try {
            const response = await axios.get(
                `https://feuerwehr-server.org:5000/benutzerByKonvKey/${konvKey}`
            );

            // Hier kannst du die Daten weiterverarbeiten oder in der Komponente verwenden
            var benutzerData = response.data.data;

            benutzerData = benutzerData.filter(function(obj){return obj.konvKey != konvKey});

            return benutzerData;
        } catch (err) {
            console.error(err);
            return false;
        }
    }
    static async getSingle(emailAdresse, passwort){
        try{
            const response = await axios.get(
                'https://feuerwehr-server.org:5000/benutzer',
                { params: { email: emailAdresse.toLowerCase(), passwort: passwort } }
            );
            if(response.data.freigeschalten){
                return response.data.konvKey;
            } else if(response.data.konvKey != null){
                return 1;
            } else{
                return false;
            }
        } catch (err){
            console.error(err);
            return false;
        }
    }
    static async getSingleWithKonvKey(konvKey){
        try {
            const response = await axios.get(
                `https://feuerwehr-server.org:5000/singleBenutzerByKonvKey/${konvKey}`
            );

            return response.data.data;
        } catch (err) {
            console.log(err);
            return false;
        }
    }
    static async getWithMail(email){
        try{
            const response = await axios.get(
                'https://feuerwehr-server.org:5000/showBenutzer-adfpij987358732498753295837',
                { params: { email: email.toLowerCase() } }
            );
            return response.data;
        } catch (err){
            console.error(err);
            return false;
        }
    }
    static async update(benutzerData){
        try {
            const response = await axios.put('https://feuerwehr-server.org:5000/updateBenutzer', benutzerData);
            console.log(response.data);
            return true;
        } catch (err) {
            console.error(err);
            return false;
        }
    }

    static async updateBenutzerFreigeschalten(email, passwort, freigeschalten){
        try {
            const response = await axios.put('https://feuerwehr-server.org:5000/updateBenutzerFreigeschalten', { email: email, passwort: passwort, freigeschalten: freigeschalten });
            console.log(response.data);
            return true;
        } catch (err) {
            console.error(err);
            return false;
        }
    }

    static async delete(email){
        try{
            await axios.delete(
                'https://feuerwehr-server.org:5000/deleteBenutzer',
                { params: { email: email } }
            );
            return true;
        } catch (err){
            console.error(err);
            return false;
        };
    }

    static async add(userData){
        try {
            const response = await axios.post('https://feuerwehr-server.org:5000/addBenutzer', userData);
            console.log('Erfolgreich registrierter Benutzer:', response.data);
            console.log(response);
            return response.data;
        } catch (error) {
            console.error(error);
            return false;
        }
    }
}
